import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { WHITELISTED_ACCOUNTS } from '@/utils/constants/constants'
import useAuthentication from '@/hooks/useAuthentication'

const RoutePrivate = ({ children, ...props }) => {
  const { authenticatedUser } = useSelector(state => state.authentication)
  const authentication = useAuthentication()

  if (
    authenticatedUser &&
    !WHITELISTED_ACCOUNTS.includes(authenticatedUser.emailAddress)
  ) {
    authentication.remove()
  }

  return (
    <Route
      {...props}
      render={() =>
        authenticatedUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/'
            }}
          />
        )
      }
    />
  )
}

export default RoutePrivate
